export namespace UserActions {
  export class SetUserProfileInformation {
    static readonly type = '[DebrisFlow User] SetUserProfileInformation';

    static readonly success = 'User profile has been set.';
    static readonly error = 'An error occurred setting user profile.';
  }

  export class SetUserImage {
    static readonly type = '[DebrisFlow User] SetUserImage';

    static readonly success = 'User image has been set.';
    static readonly error = 'An error occurred setting user image.';
  }

  export class SetUserFeatureAccess {
    static readonly type = '[DebrisFlow User] SetUserFeatureAccess';
  }

  export class GetLicenseAccess  {
    static readonly type = '[LicenseDetails] Get Licenses Access';
  }
}
